import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import AboutUs from "@/components/landing/AboutUs";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import PerformanceSection from "@/components/landing/PerformanceSection";
import Features from "@/components/landing/Features";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div
      data-testid="landing-page"
      className="relative min-h-screen overflow-x-hidden bg-[#050505] font-body text-white"
    >
      {/* Global ambient background */}
      <div className="pointer-events-none fixed inset-0 z-0">
        {/* Grid */}
        <div className="absolute inset-0 bg-grid-pattern opacity-30" />
        {/* Radial gold glow top-left */}
        <div
          className="absolute -left-40 -top-40 h-[500px] w-[500px] rounded-full opacity-30 blur-[120px] animate-float-slow"
          style={{
            background:
              "radial-gradient(circle, rgba(255,215,0,0.6) 0%, transparent 70%)",
          }}
        />
        {/* Radial cyan glow bottom-right */}
        <div
          className="absolute -right-40 bottom-40 h-[500px] w-[500px] rounded-full opacity-25 blur-[120px] animate-float-slow"
          style={{
            background:
              "radial-gradient(circle, rgba(0,240,255,0.55) 0%, transparent 70%)",
            animationDelay: "3s",
          }}
        />
        {/* Vignette */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at center, transparent 0%, #050505 90%)",
          }}
        />
      </div>

      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <PerformanceSection />
          <Features />
          <AboutUs />
          <WhyChooseUs />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </div>
  );
}
